import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { displayFontClassName } from "@/lib/fonts";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface H2Props
  extends HTMLAttributes<HTMLHeadingElement>,
    CommonComponentProps {
  type?: "promo" | "common";
}

export function H2({ children, className, type = "common", ...rest }: H2Props) {
  return (
    <h2
      className={cx(
        type === "common"
          ? cx(
              displayFontClassName,
              "text-heading-2-sm font-bold leading-[1.2] md:text-heading-2"
            )
          : "relative z-10 mb-10 bg-gradient-to-b from-foreground to-muted-foreground bg-clip-text pb-1 text-start font-sans text-6xl font-bold text-transparent md:text-8xl lg:text-9xl",
        className
      )}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </h2>
  );
}
